/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
import _ from 'lodash';
import dayjs from 'dayjs';
import env from '../../env';

import {
  REQUEST_API_KEY,
  REQUEST_API_KEY_RESULT,
  SET_GATE,
  ADD_WORK,
  REDUCE_WORK,
  API_ERROR,
  CONFIG,
  RESET_API_KEY,
  ACCEPT_TERMS_AND_CONDITIONS,
  ME,
  DISABLE_SESSION,
  MY_TAGS,
  REQUEST_API_KEY_REFRESH_RESULT,
  WARNING,
  SET_AZURE_API_KEY_RESULT,
} from './constants';
import { REQUEST_DATA_RESULT, ACCEPT_COOKIES } from '../../containers/App/constants';

const store = require('store');
const rootUrl = env.api_domain ? `${env.api_domain}/api/v1/` : '/api/v1/';

export const initialState = {
  rootUrl,
  disableSession: false,
  user: null,
  apiKey: null,
  storedRefreshToken: store.get('refresh_token'),
  rights: {
    allowCookies: store.get('permission-cookies'),
  },
  gates: {},
  work: {},
  errors: [],
  config: {},
  appConfig: null,
};

const apiReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case DISABLE_SESSION:
        draft.disableSession = true;
        break;
      case ACCEPT_COOKIES:
        draft.rights.allowCookies = true;
        store.set('permission-cookies', true);
        break;
      case RESET_API_KEY:
        draft.apiKey = null;
        store.set('refresh_token', null);
        if (action.logout) {
          window.location = '/';
        }
        break;
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case ACCEPT_TERMS_AND_CONDITIONS:
            if (action.result.result) draft.rights.hasAcceptedTermsAndConditions = true;
            break;
          case CONFIG:
            draft.config = action.result;
            draft.config.timeOffset_ms = dayjs(action.result.serverTime).diff(dayjs(new Date().getTime()), 'ms');
            try {
              draft.config.appClientId = parseInt(draft.config.appClientId, 10);
            } catch(e) {}
            break;

          case ME:
            draft.apiKey.user = action.result;
            break;
          case MY_TAGS:
            draft.myTags = action.result;
            break;
        }
        break;
      case REQUEST_API_KEY:
        draft.apiKey = null;
        break;
      case REQUEST_API_KEY_REFRESH_RESULT:
        try {
          const offset = Math.round(draft.config.timeOffset_ms ? draft.config.timeOffset_ms / 1000 : 0);

          const access_token_decoded = JSON.parse(decodeURIComponent(escape(atob(action.data.access_token.split('.')[1]))));

          const access_token_exp =
            (new Date().getTime() / 1000 + (access_token_decoded.exp - access_token_decoded.iat + offset)) * 1000;

          if (!draft.apiKey) {
            draft.apiKey = {
              valid: true,
            };
          }

          draft.apiKey.access_token = action.data.access_token;
          draft.apiKey.access_token_exp = access_token_exp;
          draft.apiKey.access_token_decoded = access_token_decoded;
        } catch (e) {
          // eslint-disable-next-line no-debugger
          debugger;
        }

        break;
      case REQUEST_API_KEY_RESULT:
        if (action.data.access_token) {
          /* eslint camelcase: 0 */
          const refresh_token_decoded = JSON.parse(
            decodeURIComponent(escape(atob(action.data.refresh_token.split('.')[1]))),
          );

          const access_token_decoded = JSON.parse(decodeURIComponent(escape(atob(action.data.access_token.split('.')[1]))));

          const offset = Math.round(draft.config.timeOffset_ms ? draft.config.timeOffset_ms / 1000 : 0) || 0;

          const refresh_token_exp =
            (new Date().getTime() / 1000 + (refresh_token_decoded.exp - refresh_token_decoded.iat + offset)) * 1000;

          const refresh_token_timeout_ms = (refresh_token_exp - new Date().getTime()) / 1000;

          const access_token_exp =
            (new Date().getTime() / 1000 + (access_token_decoded.exp - access_token_decoded.iat + offset)) * 1000;

          draft.apiKey = {
            valid: true,
            access_token: action.data.access_token,
            refresh_token: action.data.refresh_token,
            refresh_token_decoded,
            access_token_decoded,
            refresh_token_exp,
            access_token_exp,
            refresh_token_timeout_ms,
          };

          if (action.rememberMe) {
            store.set('refresh_token', {
              refresh_token: action.data.refresh_token,
              refresh_token_exp,
              decoded: refresh_token_decoded,
            });
          }

          // draft.user = action.data.user;
          // draft.rights = parseRights(action.data);
        } else {
          draft.apiKey = { valid: false };
        }
        break;
      case SET_AZURE_API_KEY_RESULT:
        if (action.data.idToken) {
          const access_token_decoded = JSON.parse(decodeURIComponent(escape(atob(action.data.idToken.split('.')[1]))));

          const offset = Math.round(draft.config.timeOffset_ms ? draft.config.timeOffset_ms / 1000 : 0) || 0;

          const access_token_exp =
            (new Date().getTime() / 1000 + (access_token_decoded.exp - access_token_decoded.iat + offset)) * 1000;

          draft.apiKey = {
            valid: true,
            access_token: action.data.idToken,
            access_token_decoded,
            access_token_exp,
            refresh_token: true,
            refresh_token_decoded: {},
            refresh_token_exp: true,
            refresh_token_timeout_ms: true,
          };
        } else {
          draft.apiKey = { valid: false };
        }
        break;
      case SET_GATE:
        draft.gates[action.id] = action.data;
        break;
      case ADD_WORK:
        addWork(draft, action.id);
        break;
      case REDUCE_WORK:
        reduceWork(draft, action.id);
        break;
      case API_ERROR:
        switch (action.action) {
          case 'set':
            draft.errors.push({
              id: action.id,
              data: action.data,
              message: action.id,
            });
            break;
          case 'unset':
            draft.errors = _.reject(draft.errors, { id: action.id });
            break;
        }
        break;
      case WARNING:
        switch (action.action) {
          case 'set':
            draft.errors.push({
              data: action.data,
              message: action.message,
            });
            break;
          case 'unset':
            draft.errors = null;
            break;
        }
        break;
    }
  });

const addWork = (draft, id) => {
  // console.log("++ work " + id);
  if (Array.isArray(id)) return _.forEach(id, id2 => addWork(draft, id2));
  if (!(id in draft.work)) draft.work[id] = 0;
  draft.work[id] += 1;
  return null;
};

const reduceWork = (draft, id) => {
  // console.log("-- work " + id);
  if (Array.isArray(id)) return _.forEach(id, id2 => reduceWork(draft, id2));
  draft.work[id] = Math.max(0, draft.work[id] - 1);
  return null;
};

/* eslint-disable-next-line no-unused-vars */
const parseRights = function(apiKey) {
  return {};
};

export default apiReducer;
